import React, { useMemo, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './traits/trait-form';


function createApp(){
    const trigger = document.querySelector<HTMLAnchorElement>('.trigger-disc-form')
    if(trigger){
        trigger.addEventListener('click', function(e){
            e.preventDefault();
            document.querySelector('.content > .subtitle').remove()
            let r = createRoot(document.querySelector('.content > .course-info'));
            r.render(<App />);
        })

        if(window.localStorage.getItem('trait'))
            trigger.innerHTML = "Ver Resultado";

        return;
    }

    let r = createRoot(document.querySelector('#root'));
    r.render(<App />);
    
}

window.addEventListener("DOMContentLoaded", createApp);